import { gql } from '@apollo/client'

export const UPDATE_SPEED_MEASUREMENT = gql`
mutation updateSpeedMeasurement($input: UpdateSpeedMeasurementInput!) {
  updateSpeedMeasurement(input: $input) {
    errors
    ticketUuid
    speedMeasurementUuid
    speedMeasurement {
      id
      laserDisplayLightsAfter
      laserDisplayLightsBefore
      laserIdStr
      laserKnownDistanceAfter
      laserKnownDistanceBefore
      laserScopeAlignmentAfter
      laserScopeAlignmentBefore
      laserSelfAfter
      laserSelfBefore
      laserTimeAfter
      laserTimeBefore
      radarDisplayLightsAfter
      radarDisplayLightsBefore
      radarIdStr
      radarInternalCalibrationAfter
      radarInternalCalibrationBefore
      radarSpeedometerVerifAfter
      radarSpeedometerVerifBefore
      radarTimeAfter
      radarTimeBefore
      radarTuningForksAfter
      radarTuningForksBefore
    }
  }
}
`